import { useState } from 'react'
import { Backdrop, CircularProgress, useTheme } from '@mui/material'

export default function LoadingBackdrop() {
  const [open, setOpen] = useState(true)
  const theme = useTheme()
  const handleClose = () => setOpen(!open)

  return (
    <Backdrop
      sx={{ color: theme.palette.background.default, zIndex: 1600 }}
      open={open}
      onClick={handleClose}
    >
      <CircularProgress color="info" size={90} />
    </Backdrop>
  )
}
